import { render, staticRenderFns } from "./InvitacionesAbonadoResumen.vue?vue&type=template&id=1779f06b"
import script from "./InvitacionesAbonadoResumen.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesAbonadoResumen.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports